export const LICENSE_SECTION_EVENT = 'canvas-agent:license:section';
export const LICENSE_UPLOAD_MODAL_EVENT = 'canvas-agent:license:upload-modal';
